class WholesaleRegisterForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.noteField = this.querySelector('[data-wholesale-note]');
    this.submitBtn = this.querySelector('[type="submit"]');

    const agreeCheckbox = this.querySelector('#WholesaleAgree');
    if (this.submitBtn) this.submitBtn.disabled = true;
    if (agreeCheckbox) {
      agreeCheckbox.addEventListener('change', () => {
        this.submitBtn.disabled = !agreeCheckbox.checked;
      });
    }

    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
  }

  onSubmit(event) {
    this.clearErrors();

    if (!this.validateFields()) {
      event.preventDefault();
      return;
    }

    this.assembleNote();
    this.submitBtn.disabled = true;
    this.submitBtn.textContent = 'Submitting...';
  }

  validateFields() {
    let isValid = true;
    let firstInvalid = null;

    const required = [
      { id: 'WholesaleBusinessName', errorKey: 'business_name', label: 'Business name' },
      { id: 'WholesaleContactPerson', errorKey: 'contact_person', label: 'Contact person' },
      { id: 'WholesaleEmail', errorKey: 'email', label: 'Email address' },
      { id: 'WholesalePassword', errorKey: 'password', label: 'Password' },
      { id: 'WholesalePhone', errorKey: 'phone', label: 'Phone number' },
      { id: 'WholesaleBusinessType', errorKey: 'business_type', label: 'Business type' },
      { id: 'WholesaleAddress', errorKey: 'address1', label: 'Address Line 1' },
      { id: 'WholesaleCity', errorKey: 'city', label: 'City' },
      { id: 'WholesalePostcode', errorKey: 'postcode', label: 'Postcode' },
    ];

    required.forEach(function ({ id, errorKey, label }) {
      const el = this.querySelector('#' + id);
      if (!el) return;
      if (!el.value.trim()) {
        this.showError(errorKey, label + ' is required');
        if (!firstInvalid) firstInvalid = el;
        isValid = false;
      }
    }.bind(this));

    // VAT format check — optional, only validate if a value is entered
    const vatInput = this.querySelector('[data-field="vat_number"]');
    if (vatInput && vatInput.value.trim()) {
      const vat = vatInput.value.trim().replace(/\s/g, '');
      if (!/^(GB)?\d{9}$/.test(vat)) {
        this.showError('vat_number', 'Enter a valid UK VAT number (e.g., GB123456789)');
        if (!firstInvalid) firstInvalid = vatInput;
        isValid = false;
      }
    }

    // Postcode format check — required + format validated if non-empty
    const postcodeInput = this.querySelector('[data-field="postcode"]');
    if (postcodeInput && postcodeInput.value.trim()) {
      if (!/^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i.test(postcodeInput.value.trim())) {
        this.showError('postcode', 'Enter a valid UK postcode (e.g., E1 6AN)');
        if (!firstInvalid) firstInvalid = postcodeInput;
        isValid = false;
      }
    }

    // "I agree" checkbox
    const agreeCheckbox = this.querySelector('#WholesaleAgree');
    if (agreeCheckbox && !agreeCheckbox.checked) {
      this.showError('agree', 'You must agree to the terms to register as a wholesale customer');
      if (!firstInvalid) firstInvalid = agreeCheckbox;
      isValid = false;
    }

    if (firstInvalid) firstInvalid.focus();
    return isValid;
  }

  assembleNote() {
    const fieldNames = ['phone', 'vat_number', 'company_reg', 'business_type', 'address1', 'city', 'postcode'];
    const data = { registration: 'wholesale_customer' };

    fieldNames.forEach(function (name) {
      const el = this.querySelector('[data-field="' + name + '"]');
      if (el && el.value.trim()) {
        data[name] = el.value.trim();
      }
    }.bind(this));

    if (data.address1 || data.city || data.postcode) {
      data.address = [data.address1, data.city, data.postcode].filter(Boolean).join(', ');
      delete data.address1;
      delete data.city;
      delete data.postcode;
    }

    this.noteField.value = JSON.stringify(data);
  }

  showError(fieldName, message) {
    const errorEl = this.querySelector('[data-error-for="' + fieldName + '"]');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.style.display = 'block';
    }
  }

  clearErrors() {
    this.querySelectorAll('.wholesale-register__field-error').forEach(function (el) {
      el.textContent = '';
      el.style.display = 'none';
    });
  }
}

customElements.define('wholesale-register-form', WholesaleRegisterForm);
